import { AdventCalendar, Event, Gallery, Library, Publication } from "./libryContentSanityTypes";
import { ArrayElement } from "./typeUtils";

export type CustomizableRepeatedEventField =
  | keyof Pick<
      Event,
      "title" | "eventStatus" | "teaser" | "body" | "promotion" | "eventSchedule" | "externalLocation" | "location"
    >;

export type AdventCalendarDoor = ArrayElement<NonNullable<AdventCalendar["doors"]>>;

export type AdventCalendarDoorType = AdventCalendarDoor["_type"];

export const isPublication = (item: unknown): item is Publication =>
  !!item && typeof item === "object" && (item as any)?.["_type"] === "publication";

export const isLibrary = (item: unknown): item is Library =>
  !!item && typeof item === "object" && (item as any)?.["_type"] === "library";

export type GalleryImage = NonNullable<Gallery["images"]>[number];
